module.exports = __webpack_public_path__ + "static/media/img_popup_info.24477638.webp";